<template>
  <v-app>
    <header class="header">
      <div class="top-line" />
      <div class="d-flex">
        <div class="header-main">
          <p
            class="company-name"
            @click="goHome">
            <span class="mr-9 text-h6">{{ `[${className ? className : 'HOME'}]` }}</span>
            삼성금융경력컨설팅센터
          </p>
          <div class="life-plan-box">
            <div>
              <div class="life-plan"><span>생애연표</span></div>
              <div class="life-plan-desc">
                <span>행복한 2nd life Re-design을 위한</span>
                <br />
                <span>설문을 작성해주세요</span>
              </div>
            </div>
          </div>
        </div>
        <div class="header-setting">
          <v-icon
            color="primary"
            large
            @click="drawer = !drawer"
            >mdi-menu</v-icon
          >
        </div>
      </div>
    </header>
    <v-navigation-drawer
      v-model="drawer"
      right
      temporary
      absolute
      color="accent2"
      dark
      style="z-index: 5">
      <v-list
        dense
        nav
        class="py-0">
        <v-list-item two-line>
          <v-list-item-avatar>
            <v-icon large>mdi-account-circle-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ userNick }}</v-list-item-title>
            <v-list-item-subtitle>{{ userEmail }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item-title>{{ className }}</v-list-item-title>
      </v-list>
      <v-divider></v-divider>
      <v-list
        subheader
        dense>
        <v-subheader class="text-h6">설문</v-subheader>
        <v-list-item
          v-for="(item, k) in items"
          :key="item.title"
          link
          :to="to[k]">
          <v-list-item-icon>
            <v-icon small>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider class="my-3"></v-divider>
      <v-list
        subheader
        dense>
        <v-subheader class="text-h6">지표</v-subheader>
        <v-list-item
          v-for="(item, n) in scores"
          :key="item.title"
          link
          :to="scoreTo[n]">
          <v-list-item-icon>
            <v-icon small>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-3"></v-divider>
        <v-subheader class="text-h6">기타</v-subheader>
        <v-list-item
          link
          @click="openUpload">
          <v-list-item-icon>
            <v-icon>mdi-mail</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>이메일 보내기</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="isSentEmail">
            <v-icon>mdi-check</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item
          link
          @click="printPage">
          <v-list-item-icon>
            <v-icon small>mdi-printer</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>인쇄하기</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item
          link
          @click="downloadBooks">
          <v-list-item-icon>
            <v-icon>mdi-download</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>교재 다운로드</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- <v-list-item link @click="download">
          <v-list-item-icon>
            <v-icon>mdi-download</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>다운로드</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item link @click="print">
          <v-list-item-icon>
            <v-icon>mdi-card-bulleted-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>결과 다운로드</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>

    <v-dialog
      v-model="downloadBookDialog"
      width="500">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-download</v-icon>
          <span>교재 다운로드</span>
          <v-spacer />
          <v-icon @click="downloadBookDialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>파일명 1</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  small
                  text
                  color="primary"
                  @click="downloadBookDialog = false">
                  다운로드
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>파일명 1</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  small
                  text
                  color="primary"
                  @click="downloadBookDialog = false">
                  다운로드
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>파일명 1</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  small
                  text
                  color="primary"
                  @click="downloadBookDialog = false">
                  다운로드
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>파일명 1</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  small
                  text
                  color="primary"
                  @click="downloadBookDialog = false">
                  다운로드
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>파일명 1</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  small
                  text
                  color="primary"
                  @click="downloadBookDialog = false">
                  다운로드
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="uploadDialog"
      width="500px"
      persistent>
      <v-card>
        <v-card-title>
          <v-icon left>mdi-send</v-icon>
          <span>{{ isUploaded ? '업로드 완료' : '결과지 이메일 전송' }}</span>
          <v-spacer />
          <v-icon @click="uploadCancel">mdi-close</v-icon>
        </v-card-title>
        <template v-if="!isUploaded">
          <v-card-text>
            <v-file-input
              v-model="fileObj"
              hide-details
              placeholder="다운로드한 결과 파일(pdf)을 선택하세요."
              label="결과 파일 업로드"
              prepend-icon="mdi-file-pdf-box"
              accept="application/pdf"
              truncate-length="60"
              @change="selectFile">
            </v-file-input>
            <br />
            <br />
            <br />
            <br />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              dark
              depressed
              @click.stop="uploadFile">
              <v-icon left>mdi-upload</v-icon>
              업로드
            </v-btn>
          </v-card-actions>
        </template>
        <template v-else>
          <v-card-text>
            파일 업로드가 완료되었습니다.<br />
            아래 이메일로 결과 PDF를 보내드립니다. <br /><br />

            <p class="subtitle-1">{{ userEmail }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="uploadOK"
              >확인</v-btn
            >
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="350">
      <v-card>
        <v-card-title class="headline">
          <v-icon
            left
            large
            color="primary"
            >mdi-download</v-icon
          >
          파일 다운로드
          <v-spacer />
          <v-icon
            large
            @click="dialog = false"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="파일이름을 입력하세요"
            suffix=".json"
            v-model="filename"
            clearable
            append-outer-icon="mdi-folder-zip"
            v-on:keyup.enter="exportReport"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn
            dark
            color="primary lighten-1"
            block
            @click="exportReport"
            >확인</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-main>
      <router-view />
    </v-main>
    <v-footer
      app
      class="justify-center footer"
      color="white">
      <div><span>&copy;삼성금융경력컨설팅센터</span></div>
    </v-footer>
  </v-app>
</template>

<script>
import axios from 'axios'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import { saveAs } from 'file-saver'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { format } from 'date-fns'
import { ko } from 'date-fns/locale'
// import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

const _axios = axios.create({
  timeout: 10000,
  headers: {},
})
export default {
  name: 'Main',
  components: {
    // vueDropzone,
  },

  data: () => ({
    fileObj: null,
    uploadDialog: false,
    downloadBookDialog: false,
    isUploaded: false,
    dialog: false,
    filename: '',
    drawer: false,
    items: [
      { title: 'Life', icon: 'mdi-heart-multiple', to: '/master' },
      { title: 'Family', icon: 'mdi-home', to: '/life' },
      { title: 'Finance', icon: 'mdi-finance', to: '/finance' },
      { title: 'Career', icon: 'mdi-briefcase', to: '/career' },
      { title: 'Action Plan', icon: 'mdi-map-marker-star-outline', to: '/action' },
    ],
    scores: [
      { title: 'Life', icon: 'mdi-heart-multiple', to: '/score/master' },
      { title: 'Family', icon: 'mdi-home', to: '/score/life' },
      { title: 'Finance 1p', icon: 'mdi-finance', to: '/score/finance' },
      { title: 'Finance 2p', icon: '', to: '/score/finance2' },
      { title: 'Career 1p', icon: 'mdi-briefcase', to: '/score/career' },
      { title: 'Career 2p', icon: '', to: '/score/career2' },
      { title: 'Action Plan', icon: 'mdi-map-marker-star-outline', to: '/score/action' },
    ],
    //
  }),
  computed: {
    ...mapState(['userNick', 'userEmail', 'className', 'classId', 'isSentEmail', 'uploadFileId']),
    to() {
      return [`/${this.classId}/master`, `/${this.classId}/life`, `/${this.classId}/finance`, `/${this.classId}/career`, `/${this.classId}/action`]
    },
    scoreTo() {
      return ['/score/master', '/score/life', '/score/finance', '/score/finance2', '/score/career', '/score/career2', '/score/action'].map((s) => '/' + this.classId + s)
    },
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light'
    },
    ...mapGetters(['exportData', 'isLoggedIn']),
  },
  methods: {
    ...mapMutations(['setUploadFileId', 'setSentEmail']),
    ...mapActions(['submit']),
    async uploadFile() {
      const { url, uploadUrl } = this.upload
      const filename = format(new Date(), 'yyyy-MM-dd HH:mm_', { locale: ko }) + this.fileObj.name
      // console.log(filename)
      delete _axios.defaults.headers.common['Authorization']
      return _axios
        .put(uploadUrl, this.fileObj, {
          headers: {
            'Content-Type': 'application/pdf',
          },
        })
        .then(() => {
          return this.axios
            .post(`/api/files`, {
              path: this.classId + '/' + this.userEmail,
              tags: [],
              type: 'scoreSheet',
              classId: this.classId,
              email: this.userEmail,
              contentType: 'application/pdf',
              name: filename,
              url,
              createdAt: new Date().toISOString(),
            })
            .then(({ data }) => {
              const { insertedId: id } = data
              this.setSentEmail()
              this.setUploadFileId(id)
              this.submit()
              this.isUploaded = true
            })
        })
    },

    async selectFile() {
      const r = await this.axios.get(`/api/file/presignedUrl?suffix=pdf&type=scoreSheet&classId=${this.classId}&email=${this.userEmail}`).then(({ data }) => {
        const { url } = data
        const u = url.split(/\?/)[0]
        const key = u.split(/\//).pop()
        const filename = key

        this.upload = {
          uploadUrl: url,
          url: 'https://files.samsungccc.com/' + this.classId + '/' + this.userEmail + '/' + filename,
        }
      })

      // this.$refs.dropzone.manuallyAddFile(this.fileObj, this.$refs.dropzone.files.length)
    },
    downloadBooks() {
      if (!this.isLoggedIn) {
        alert('로그인이 필요합니다.')
      } else this.downloadBookDialog = true
    },
    printPage() {
      const {
        params: { classId },
      } = this.$route
      this.$router.push({ name: 'All', classId })
    },
    async print() {
      // domtoimage.toBlob(document.querySelector('main')).then(function(blob) {
      //   saveAs(blob, 'my-node.png')
      // })
      const page = await html2canvas(document.querySelector('main')).then(function (canvas) {
        var doc = new jsPDF('l', 'mm', 'a4') //jspdf객체 생성
        var imgData = canvas.toDataURL('image/png') //캔버스를 이미지로 변환
        var width = doc.internal.pageSize.getWidth()
        const imgProps = doc.getImageProperties(imgData)
        const pdfHeight = (imgProps.height * width) / imgProps.width
        doc.addImage(imgData, 'PNG', 0, 0, width, pdfHeight) //이미지를 기반으로 pdf생성
        return doc

        // let dataURL = canvas.toDataURL('image/png')
        // dataURL = dataURL.replace(/^data:image\/[^;]*/, 'data:application/octet-stream')
        // dataURL = dataURL.replace(/^data:application\/octet-stream/, 'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=Canvas.png')
        // return dataURL
        // return canvas.toBlob((blob) => blob)
      })
      const fileName = `${this.userNick}_${this.$route.name}.pdf`
      page.save(fileName) //pdf저장

      // saveAs(img, fileName)
      // const aTag = document.createElement('a')
      // const fileName = `${this.userNick}_${this.$route.name}.png`
      // aTag.download = fileName
      // aTag.href = img
      // aTag.click()
      // document.body.removeChild(aTag)
    },
    async goHome() {
      const confirm = await this.$dialog.confirm({
        text: `지금까지 작업하고 있던 설문을 삭제하고 종료됩니다.
        진행 하시겠습니까?`,
        type: 'error',
        title: '확인',
      })
      if (!confirm) return
      this.initialize()
      this.$router.push('/')
    },
    ...mapMutations(['loadFile', 'setExample', 'setClass', 'initialize']),
    openUpload() {
      this.upload = {
        filename: '',
        targetEntityName: '',
        userEmail: '',
        orgName: '',
        createdAt: '',
      }
      this.noFile = true
      this.isUploaded = false
      this.uploadDialog = true
    },
    uploadOK() {
      this.isUploaded = false
      this.uploadDialog = false
      // this.loadFile(this.upload.data)
      // this.$router.push('/reports')
    },
    uploadCancel() {
      this.isUploaded = false
      this.uploadDialog = false
    },
    download() {
      this.dialog = true
    },
    exportReport() {
      this.dialog = false

      const fileName = this.filename.replace(/\s/g, '_')
      const exp = this.exportData
      exp.createdAt = new Date().toJSON()

      // console.log("exportReport");
      console.log(exp)

      // console.log(base64)

      //한글문제때문에 unicode 16으로 변경해서처리
      // const dataOut = base64.encode(JSON.stringify(exp))
      var blob = new Blob([JSON.stringify(exp)], { type: 'text/plain;charset=utf-8' })
      saveAs(blob, fileName + '.json')

      function s2ab(s) {
        var buf = new ArrayBuffer(s.length) //convert s to arrayBuffer
        var view = new Uint8Array(buf) //create uint8array as viewer
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff //convert to octet
        return buf
      }
      // saveAs(
      //   new Blob([s2ab(wbOut)], { type: "application/octet-stream" }),
      //   "표준감사시간-" + this.companyTitle + ".xlsx"
      // );
    },
  },
}
</script>
<style lang="scss">
.q-message {
  color: #5878b8;
  font-size: 24px !important;
}
.main-container {
  background-image: url('/images/left-bottom.svg');
  background-repeat: no-repeat;
  background-size: 467px;
  background-position: 0px 0px;
  // padding: 0px 50px;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}
.swiper {
  min-height: 580px;
  height: 600px;
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
// .box {
// border: 2px solid red;
// }
.content-box {
  // margin-top: 50px;
  min-height: 560px;
  width: 900px;
  margin-left: auto;
  margin-right: auto;
}
.bottom-bar {
  min-width: 1000px;
  min-height: 70px;
  max-height: 80px;
  padding: 0px 50px;
}
.footer {
  font-weight: 600;
}
.uploadBoxTitle {
  margin-top: 0;
  color: #bcbcbc;
}
.uploadBox {
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.2px;
  transition: all 0.5 linear;
  height: 350px;
  padding: 12px;
  border: 2px dashed #bcbcbc;
}
.v-footer {
  padding: 0px 0px 20px 0px !important;
  color: grey !important;
  letter-spacing: -1px;
}
header.header {
  width: 100%;
  height: 200px;
  background-image: url('/images/left-top.svg');
  background-repeat: no-repeat;
  background-size: 800px 200px;
  background-position: 0px 0px;
  letter-spacing: -1px;
  // background-image: url("/images/top-line.svg");
  // background-repeat: repeat-x;
  // background-size: contain;
  .top-line {
    width: 100%;
    height: 24px;
    background-color: #70cae9;
  }
  .header-main {
    flex: 1;
  }
  .header-setting {
    min-width: 80px;
    max-width: 80px;
    padding-left: 10px;
    padding-top: 45px;
  }

  .company-name {
    width: 100%;
    padding: 22px 10px 0px 0px;
    text-align: right;
    font-weight: 900;
    font-size: 20px;
    // color: #5878b8;
    color: #293289;
    margin-bottom: 10px !important;
  }
  .life-plan-box {
    float: right;
    width: 50%;
    min-width: 500px;
    height: 100px;
    padding-right: 10px;
    > div {
      padding-top: 10px;
      // border-top: 1px solid #5878b8;
      border-top: 1px solid #293289;
      display: flex;
      align-items: center;
    }
    span {
      // color: #5878b8;
      color: #293289;
    }
    .life-plan-desc {
      margin-left: 17px;
      padding-left: 17px;
      height: 100%;
      // border-left: 1px solid #5878b8;
      border-left: 1px solid #293289;
      span {
        font-size: 16px;
        font-weight: 600;
      }
    }
    .life-plan {
      span {
        font-size: 48px;
        font-weight: 900;
      }
    }
  }
}
</style>
